import {
  getProductCatalogs,
  removeProductCatalog,
  setProductCatalogFilters,
  updateProductCatalog,
} from '@state/reducers/productCatalogReducer'
import { ProductCatalogDto } from '@services/dtos'
import { useEffect, useState } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import ProductCatalogForm from '../forms/productCatalog/ProductCatalogForm'
import { productCatalogsColumns } from '@utils/gridColumns'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Dialog, DialogContent } from '@mui/material'
import { UpTransition } from '../animations'

export default function ProductCatalogsTable() {
  const [duplicateProduct, setDuplicateProduct] = useState<ProductCatalogDto | null>(null)
  const [duplicateFormOpen, setDuplicateFormOpen] = useState(false)
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setProductCatalogFilters({ includeInactive: false }))
    }
  }, [])

  return (
    <>
      <BaseConfigTable<ProductCatalogDto>
        columns={productCatalogsColumns}
        selectRows={(state) => state.productCatalog.items}
        extraActions={[
          {
            key: 'duplicate',
            label: 'Dupliquer',
            icon: <ContentCopyIcon color="primary" fontSize='small' />,
            onClick: (row) => {
              setDuplicateProduct(row)
              setDuplicateFormOpen(true)
            },
          },
        ]}
        fetchThunk={() => async (dispatch: AppDispatch) => {
          dispatch(setProductCatalogFilters({ includeInactive: true }))
          return dispatch(getProductCatalogs())
        }}
        deleteThunk={removeProductCatalog}
        toggleThunk={(id, isActive) => updateProductCatalog({ id, dto: { isActive } })}
        updatePageThunk={(page) => async (dispatch: AppDispatch) => {
          dispatch(setProductCatalogFilters({ page }))
          dispatch(getProductCatalogs())
        }}
        FormComponent={({ editingItem, onClose }) => (
          <ProductCatalogForm editingProductCatalog={editingItem} onClose={onClose} />
        )}
        formMaxWidth='md'
        resourceLabel="catalogue de produits"
        resourcePrefix="le "
      />

      <Dialog 
        fullWidth
        maxWidth="md"
        open={duplicateFormOpen} 
        TransitionComponent={UpTransition}
        onClose={() => setDuplicateFormOpen(false)}>
        <DialogContent>
          <ProductCatalogForm
            duplicateCase
            editingProductCatalog={duplicateProduct}
            onClose={() => setDuplicateFormOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
